"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var PricingInsights_1 = __importDefault(require("containers/MyStack/PricingInsights"));
var queries_1 = require("utils/firebase/queries");
var ordered_1 = require("utils/selectors/ordered");
var AboutTool_1 = __importDefault(require("../AboutTool"));
var OtherTools_1 = __importDefault(require("../OtherTools"));
var ServiceIntro_1 = __importDefault(require("../ServiceIntro"));
var SingleToolHeader_1 = __importDefault(require("../SingleToolHeader"));
var UnlockDeal_1 = __importDefault(require("../UnlockDeal"));
var index_1 = __importDefault(require("./ToolChat/index"));
var ToolView = function (_a) {
    var service = _a.service;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [(0, queries_1.serviceComparisonsQuery)(service)]; });
    var otherTools = (0, react_redux_1.useSelector)((0, ordered_1.makeSelectServiceComparisons)(service.id));
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ spacing: 4, ml: 0, container: true, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, sm: 8 }, { children: [(0, jsx_runtime_1.jsx)(SingleToolHeader_1.default, { service: service }), (0, jsx_runtime_1.jsx)(index_1.default, { serviceId: service.id }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ borderBottom: "1px solid lightgray", mb: 8 }, { children: (0, jsx_runtime_1.jsx)(PricingInsights_1.default, { service: service }) })), (service === null || service === void 0 ? void 0 : service.videoData) && (0, jsx_runtime_1.jsx)(ServiceIntro_1.default, { videoData: service.videoData, serviceName: service.name }), service && (0, jsx_runtime_1.jsx)(AboutTool_1.default, { service: service }), (0, jsx_runtime_1.jsx)(OtherTools_1.default, { otherTools: otherTools, currentService: service })] })), !(0, isEmpty_1.default)(service === null || service === void 0 ? void 0 : service.deals) && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, sm: 4 }, { children: (0, jsx_runtime_1.jsx)(UnlockDeal_1.default, { service: service }) })))] })));
};
exports.default = ToolView;
